var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { browserStorage } from '../browserStorage';
export var SOUND_KEY = {
    MODAL_SETTINGS_OPEN: 'MODAL_SETTINGS_OPEN',
    MODAL_OPEN: 'MODAL_OPEN',
    MODAL_CLOSE: 'MODAL_CLOSE',
    BUTTON_CLICK: 'BUTTON_CLICK',
    BUTTON_SLIDE_CLICK: 'BUTTON_SLIDE_CLICK',
    NEW_NOTIFICATION: 'NEW_NOTIFICATION',
    NEW_MESSAGE: 'NEW_MESSAGE',
};
var SOUNDS_KEY = (_a = {},
    _a[SOUND_KEY.MODAL_OPEN] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-game-user-interface-tone-2570.wav',
    _a[SOUND_KEY.MODAL_SETTINGS_OPEN] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-glass-hitting-a-metal-2183.wav',
    _a[SOUND_KEY.MODAL_CLOSE] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-night-vision-starting-2476.wav',
    _a[SOUND_KEY.BUTTON_CLICK] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-light-button-2580.wav',
    _a[SOUND_KEY.BUTTON_SLIDE_CLICK] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-slide-click-1130.wav',
    _a[SOUND_KEY.NEW_NOTIFICATION] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-game-balloon-or-bubble-pop-3069.wav',
    _a[SOUND_KEY.NEW_MESSAGE] = 'https://izi-logistics-prod.s3.us-east-2.amazonaws.com/public/sounds/mixkit-explainer-video-game-alert-sweep-236.wav',
    _a);
var Sounds = /** @class */ (function () {
    function Sounds() {
        var _this = this;
        this.sounds = {};
        if (browserStorage.getItem('sounds')) {
            Object.keys(SOUNDS_KEY).forEach(function (key) {
                try {
                    _this.sounds[key] = new Audio(SOUNDS_KEY[key]);
                    _this.sounds[key].volume = 0.2;
                }
                catch (e) { }
            });
        }
    }
    Sounds.prototype.play = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!SOUNDS_KEY[key])
                            return [2 /*return*/];
                        if (!browserStorage.getItem('sounds')) return [3 /*break*/, 2];
                        if (!this.sounds[key]) {
                            this.sounds[key] = new Audio(SOUNDS_KEY[key]);
                            this.sounds[key].volume = 0.2;
                        }
                        return [4 /*yield*/, this.sounds[key].play()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Sounds;
}());
export default Sounds;
